import { render, h } from 'preact';
import { Controller } from "stimulus"
import RequestQueue from 'classes/RequestQueue';
import _ from 'lodash';

const mapping = {
  default: {
    title: 'Own the best dividend stocks.',
    message: 'Only our highest-rated stocks based on overall quality make the cut.',
    cancel_text: 'No thanks',
    proceed_text: 'Get it now',
    variant: 'mitre-purple-400'
  }
}

export default class extends Controller {
  async connect() {
    const key = this.element.getAttribute('data-modal-key') || 'default';
    const url = this.element.getAttribute('data-modal-url');
    const location = this.element.getAttribute('data-modal-location');
    const resource = this.element.getAttribute('data-resource');
    let modalData = mapping.default;
    if (url) {
      try {
        const ctaDataPath = _.compact(['cta', window.websiteProperty, key, location, resource]);
        if (_.has(window.MConstants, ctaDataPath)) {
          modalData = _.get(window.MConstants, ctaDataPath);
        } else {
          const { data } = await RequestQueue.addToQueue({
            method: 'post',
            url: url,
            data: {
              property: window.websiteProperty,
              key,
              location,
              resource: JSON.parse(resource || '{}')
            },
            cached: true
          })
          _.set(window.MConstants, ctaDataPath, data);
          modalData = data;
        }
        const { button_text } = modalData;
        this.element.classList.remove('t-text-transparent');
        if (button_text.length > 0) {
          this.element.textContent = button_text;
        }
        this.modalData = modalData;
      } catch (e) {
        // proceed with error
      }
    }
  }

  async showModal(e) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();

    const modal = render(
      <Modal
        title={this.modalData['title']}
        message={this.modalData['message']}
        cancelText={this.modalData['cancel_text']}
        proceedText={this.modalData['proceed_text']}
        colorClass={`t-bg-${this.modalData['variant']}`}
        modalDslName={this.modalData['dsl_name'] || ''}
        options={this.modalData['options']}
        modal={modal}
      />, document.body
    )
  }
}

const Modal = ({ title, message, cancelText, proceedText, colorClass, modalDslName, options, modal }) => {

  const closeModal = e => {
    e.preventDefault();
    render(null , document.body, modal)
  }

  return (
    <div className="t-fixed t-top-0 t-left-0 t-w-screen t-h-screen t-z-1500 t-flex" style={{ backgroundColor: 'rgba(34, 34, 34, 0.5)' }} data-modal-dsl-name={modalDslName}>
      <div className={`t-relative t-w-100 t-h-auto md:t-min-h-40 t-mx-4 t-my-auto md:t-mx-auto t-flex t-p-12 ${colorClass} t-flex-col t-justify-between`}>
        <div className="t-flex t-flex-col">
          <div className="t-flex t-flex-row t-justify-between t-items-center t-mb-6 t-flex-wrap md:t-flex-nowrap">
            <img src="/dividend-premium-logo.svg" className="t-w-max t-mb-3 md:t-mb-0"></img>
            { 
              options ? (
                JSON.parse(options)['is_mp'] ? (
                  <span class="t-bg-mitre-yellow-300 t-text-mitre-blue-400 t-font-semibold t-leading-tighter t-text-xs t-px-2 t-rounded-md t-py-1 t-uppercase t-flex t-items-center">
                    <span class="t-h-5 t-w-5">
                      <svg fill="none" width="100" xmlns="http://www.w3.org/2000/svg">
                        <g>
                          <path d="M10 12.5C13.2217 12.5 15.8334 9.88837 15.8334 6.66671C15.8334 3.44505 13.2217 0.833374 10 0.833374C6.77836 0.833374 4.16669 3.44505 4.16669 6.66671C4.16669 9.88837 6.77836 12.5 10 12.5Z" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="#1E037E"></path>
                          <path d="M6.84165 11.575L5.83331 19.1666L9.99998 16.6666L14.1666 19.1666L13.1583 11.5667" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="#1E037E"></path>
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect fill="white" height="20" width="20"></rect>
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    Model Portfolio
                  </span>
                ) : ''
              ) : ''
            }
          </div>
          <p className="t-text-4xl t-font-bold t-leading-none">
            { title }  
          </p>
          <p className="m-text-body-fw-400-lh-lg t-mt-4">
            { message }
          </p>
        </div>
        <div className="t-flex t-justify-end t-pt-6">
          <a href="#" className="t-text-base t-font-semibold t-text-mitre-blue-200 t-uppercase hover:t-text-mitre-blue-300 t-mr-6" onClick={closeModal} data-exit-control>
            { cancelText }
          </a>
          <a href="/pricing/" className="t-text-base t-font-semibold t-text-mitre-blue-200 t-uppercase hover:t-text-mitre-blue-300">
            { proceedText }
          </a>
        </div>
      </div>
    </div>
  )
}
